"use client"
import * as React from 'react'
import _ from "underscore"
import Accordion from '@mui/material/Accordion'
import Typography from '@mui/material/Typography'
import {TranslationContext} from '@/configs/context'
import {Box, useMediaQuery, useTheme} from "@mui/material"
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const FAQ_QUESTIONS_LENGTH = process.env.NEXT_PUBLIC_FAQ_QUESTIONS_LENGTH

export default function FaqList() {
  const theme = useTheme()
  const { t }: object = React.useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Box
      id="faq-section"
      sx={{
        py: { xs: 6, md: 8 },
        color: "common.white",
        px: { xs: 0, md: 1 },
      }}
    >
      <Typography
        color="text.primary"
        variant={matchMd ? "h4" : "h5"}
        sx={{ textAlign: "center", marginBottom: "2rem" }}
      >
        {t('translation:faq.title')}
      </Typography>
      {_.range(parseInt(FAQ_QUESTIONS_LENGTH)).map(function (order) {
        const key = `vcard-faq-${order}`

        return (
          <Accordion
            key={key}
            sx={{ mb: 1, "&::before": { height: 0 } }}
            slotProps={{ transition: { unmountOnExit: true } }}
          >
            <AccordionSummary
              id={`panel-${key}-header`}
              aria-controls={`panel-${key}-content`}
              expandIcon={<ArrowDownwardIcon sx={{ color: "common.white" }} />}
            >
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {t(`translation:faq.question${order+1}`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography align="justify">
                {t(`translation:faq.response${order+1}`)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )
      })}
    </Box>
  )
}
